import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, Observable} from 'rxjs';
import {GridGetService, GridServiceParams, GridServiceResponse} from 'src/app/shared/model/page-grid';
import {removeEmptyParams} from 'src/infrastructure/helper/remove-empty-params';
import {KtTripsFilterService} from './kt-trips-filter.service';
import {IKtTripListItem} from '../interfaces/kt-trip.interface';
import moment from 'moment';

@Injectable({providedIn: 'root'})
export class KtTripsGridService implements GridGetService<IKtTripListItem> {
  private readonly baseUrl = 'tmt/sales-orders/kt-trips';
  private readonly http = inject(HttpClient);
  private readonly filterService = inject(KtTripsFilterService);

  getItems({page, sort}: GridServiceParams): Observable<GridServiceResponse<IKtTripListItem>> {
    const filters = this.filterService.filtersValue();

    const params: Record<string, string | number | boolean | string[] | number[]> = {
      pageSize: page?.pageSize || 25,
      pageNumber: (page?.pageIndex || 0) + 1,
      propertyName: sort?.active || '',
      orderKey: sort?.direction || '',
      tripReference: filters?.TripReference ?? '',
      clientName: filters?.ClientName ?? '',
      agentName: filters?.AgentName ?? '',
      vendorName: filters?.VendorName ?? '',
      bookedDateFrom: filters?.BookedDateFrom ? moment(filters.BookedDateFrom).format('YYYY-MM-DD') : '',
      bookedDateTo: filters?.BookedDateTo ? moment(filters.BookedDateTo).format('YYYY-MM-DD') : '',
      tripStartDateFrom: filters?.TripStartDateFrom ? moment(filters.TripStartDateFrom).format('YYYY-MM-DD') : '',
      tripStartDateTo: filters?.TripStartDateTo ? moment(filters.TripStartDateTo).format('YYYY-MM-DD') : '',
      ...(filters?.IsCancelled !== null && filters?.IsCancelled !== undefined ? {isCancelled: filters.IsCancelled} : {}),
    };

    removeEmptyParams(params);

    return this.http.get<GridServiceResponse<IKtTripListItem>>(this.baseUrl, {params: {...params}})
      .pipe(catchError((error: HttpErrorResponse) => {
        throw new Error(error?.message || 'Server error');
      }));
  }
}
